(function ($) {
  "use strict";

  window.QLD = window.QLD || {};
  const SCROLL_AMOUNT = 500;

  function scrollTabsRight($tabsContainer, $rightButton, $leftButton) {
    if ($tabsContainer[0].scrollLeft + SCROLL_AMOUNT >= $tabsContainer[0].scrollWidth - $tabsContainer[0].clientWidth) {
      $rightButton.hide();
    }
    $tabsContainer[0].scrollLeft += SCROLL_AMOUNT;
    $leftButton.show();
  }

  function scrollTabsLeft($tabsContainer, $rightButton, $leftButton) {
    if ($tabsContainer[0].scrollLeft - SCROLL_AMOUNT <= 0) {
      $leftButton.hide();
    }
    $tabsContainer[0].scrollLeft -= SCROLL_AMOUNT;
    $rightButton.show();
  }

  function handleOverflow($container, $tabs, $rightButton, $leftButton) {
    const $buttons = $tabs.find(".qld__tab-button");
    let totalWidth = 0;

    $buttons.each(function () {
      totalWidth += $(this).outerWidth(true);
    });

    if (totalWidth > $container.outerWidth()) {
      $rightButton.show();
      $tabs[0].scrollLeft -= SCROLL_AMOUNT;
      $leftButton.hide();
    } else {
      $rightButton.hide();
      $leftButton.hide();
    }
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  function cleanEmptyNavLinks() {
    $(".qld__tab-content").each(function () {
      const $tabContent = $(this);
      const $links = $tabContent.find(".qld__inpage-nav-links li a");

      if (!$links.length) return;

      $links.each(function () {
        const $link = $(this);
        let href = $link.attr("href");
        href = escapeSelector(href);

        if (!$tabContent.find(href).length) {
          $link.parent().remove();
        }
      });
    });

    $(window).off("scroll", triggerRecheck);
  }

  function escapeSelector(selector) {
    if (!selector) return "";
    return selector.replace(/([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g, '\\$1');
  }

  function setupRecheckClick() {
    $(".qld__tab-button").each(function () {
      cleanEmptyNavLinks();
      $(this).on("click", cleanEmptyNavLinks);
    });
  }

  function triggerRecheck() {
    setupRecheckClick();
  }

  const QLDTabModule = {
    init: function () {
      $(".qld__tab-container").each(function () {
        const $container = $(this);
        const $tabButtons = $container.find(".qld__tab-button");

        if ($tabButtons.length) {
          const $firstButton = $tabButtons.first();
          $firstButton.attr({
            tabindex: "0",
            "aria-selected": "true"
          }).addClass("active");

          const tabId = $firstButton.data("tab");
          const $firstContent = $container.find(`.qld__tab-content[data-tab="${tabId}"]`);
          if ($firstContent.length) {
            $firstContent
              .attr({
                tabindex: "0",
                "aria-hidden": "false"
              })
              .addClass("active");
          }
        }

        $tabButtons.each(function () {
          $(this).on("click", function () {
            $tabButtons.removeClass("active").attr({
              "aria-selected": "false",
              tabindex: "-1"
            });
            $container.find(".qld__tab-content").removeClass("active").attr({
              "aria-hidden": "true",
              tabindex: "-1"
            });

            const $this = $(this);
            $this.addClass("active").attr({
              "aria-selected": "true",
              tabindex: "0"
            });

            const selectedTab = $this.data("tab");
            const $selectedContent = $container.find(`.qld__tab-content[data-tab="${selectedTab}"]`);
            $selectedContent.addClass("active").attr({
              "aria-hidden": "false",
              tabindex: "0"
            });
          });
        });

        // Keyboard navigation
        let currentIndex = 0;

        function focusTab(index, $tabs) {
          if (!$tabs.length) return;
          index = (index + $tabs.length) % $tabs.length;
          setTimeout(() => $tabs.eq(index).focus(), 50);
        }

        $tabButtons.each(function (index) {
          $(this).on("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              $(this).click();
            } else if (e.key === "ArrowLeft") {
              e.preventDefault();
              currentIndex = (index - 1 + $tabButtons.length) % $tabButtons.length;
              focusTab(currentIndex, $tabButtons);
            } else if (e.key === "ArrowRight") {
              e.preventDefault();
              currentIndex = (index + 1) % $tabButtons.length;
              focusTab(currentIndex, $tabButtons);
            }
          });

          $(this).on("focus", function () {
            currentIndex = index;
            const tabId = $(this).data("tab");
            $container.find(`.qld__tab-content[data-tab="${tabId}"]`).addClass("focused");
          });

          $(this).on("blur", function () {
            const tabId = $(this).data("tab");
            $container.find(`.qld__tab-content[data-tab="${tabId}"]`).removeClass("focused");
          });
        });
      });

      // Overflow buttons setup
      const $fixedContainers = $(".qld__tab-container__fixed");
      const tabWrappers = [];

      $fixedContainers.each(function () {
        tabWrappers.push($(this).find(".qld__tabs").first());
      });

      $fixedContainers.each(function (index) {
        const $container = $(this);
        const $tabs = tabWrappers[index];
        const $rightBtn = $container.find(".tab-overflow-nav-button-right");
        const $leftBtn = $container.find(".tab-overflow-nav-button-left");

        $(window).on("load", () => handleOverflow($container, $tabs, $rightBtn, $leftBtn));
        $(window).on("resize", debounce(() => handleOverflow($container, $tabs, $rightBtn, $leftBtn), 250));
        $rightBtn.on("click", () => scrollTabsRight($tabs, $rightBtn, $leftBtn));
        $leftBtn.on("click", () => scrollTabsLeft($tabs, $rightBtn, $leftBtn));
      });
    }
  };

  QLD.tab = QLDTabModule;

  $(function () {
    QLD.tab.init();
    setupRecheckClick();
  });

  $(window).on("scroll", triggerRecheck);

})(jQuery);